import { ProductInNew } from 'app/pages/NewAccount/types';
import { BaseXHR } from 'utils/axios';

export const getLayoutApi = () => BaseXHR.$get('b2b/v1/page/layout');

export const getTranslationsApi = () => BaseXHR.$get('b2c/translator/listing');

export const getTranslationsB2BApi = () =>
  BaseXHR.$get('b2b/v1/translator/listing');

export const getTopBestSellingTicketsApi = () =>
  BaseXHR.$get<{ data: ProductInNew[] }>('promotions/topSale');

export const getNationalApi = () => BaseXHR.$get('b2b/v1/nation/listing');
export const getProvinceApi = nationalId =>
  BaseXHR.$get('b2b/v1/nation/provinces/' + nationalId);
export const getDistrictApi = provinceId =>
  BaseXHR.$get('b2b/v1/nation/district/' + provinceId);

export const getPolicyPages = () =>
  BaseXHR.$get<{
    policy: {
      delivery_content_policy: string;
      give_back_content_policy: string;
      payment_content_policy: string;
      security_content_policy: string;
    };
  }>('b2c/page/policy');

export const getMaintenanceApi = () => BaseXHR.$get('b2b/v1/page/maintain');
